import getUserAgent from '@/helpers/userAgent/getUserAgent';

const isSafari = () => {
  const userAgent = getUserAgent().toLowerCase();
  return userAgent.includes('safari') && !userAgent.match(/chrome|firefox/);
};

export default isSafari;
